import styled from 'styled-components';
import { createButtonElement, getButtonStyles, } from '../../Components/Interactive/Button/ButtonHelpers';
const StyledButtonLink = styled.a `
	${(props) => getButtonStyles(props.$buttonProps, props.theme)}
	text-decoration: none;
`;
const ButtonLink = createButtonElement(StyledButtonLink, 'ButtonLink');
export default ButtonLink;
//# sourceMappingURL=ButtonLink.js.map